module.exports = __webpack_public_path__ + "img/bg_rhombus.819e8075.png";